/*! @azure/msal-browser v4.20.0 2025-08-12 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isBridgeError(error) {
    return error.status !== undefined;
}

export { isBridgeError };
//# sourceMappingURL=BridgeError.mjs.map
